<script lang="ts">
	import decorationFooter from "@assets/images/deco/decoration - footer.svg";
	import facebookIcon from "@core/assets/icons/fb.svg?raw";
	import instagramIcon from "@core/assets/icons/ig.svg?raw";
	import tiktokIcon from "@core/assets/icons/tiktok.svg?raw";
	import logo from "@core/assets/logo-footer.svg?raw";
	import Formatted from "../common/Formatted.svelte";
	import Icon from "../common/Icon.svelte";

	interface Props {
		isHomepage?: boolean;
	}

	const { isHomepage = false }: Props = $props();

	const socialLinks = [
		{ icon: instagramIcon, href: "https://www.instagram.com/headspa_napohodu_karvina", label: "Instagram" },
		{
			icon: facebookIcon,
			href: "https://www.facebook.com/p/HEAD-SPA-napohodu-Karvin%C3%A1-61572775493911/",
			label: "Facebook",
		},
		{ icon: tiktokIcon, href: "https://www.tiktok.com/@headspa_napohodu_karvina", label: "TikTok" },
	];
</script>

<div class="full-width flex flex-col">
	<div
		class="flex flex-col md:flex-row justify-center items-center px-4 md:px-8 lg:px-16 xl:px-24 py-8 md:py-12 xl:py-16 gap-4 md:gap-6 xl:gap-8 bg-ivory-100"
	>
		<p class="text-text-mobile md:text-pmd font-medium tracking-[0.02em] text-midnight text-center">
			<Formatted text="Sledujte nás na sociálních sítích" />
		</p>
		<div class="flex items-center gap-3 md:gap-4">
			{#each socialLinks as social (social.href)}
				<a
					href={social.href}
					target="_blank"
					rel="noopener noreferrer"
					class="flex justify-center items-center w-12 h-12 md:w-14 md:h-14 xl:w-16 xl:h-16 bg-copper-300 rounded-[1.5rem] md:rounded-[1.75rem] xl:rounded-[2rem] hover:bg-copper-200 transition-colors"
					aria-label={social.label}
				>
					<Icon icon={social.icon} class="w-6 h-6 md:w-7 md:h-7 xl:w-8 xl:h-8 text-white" />
				</a>
			{/each}
		</div>
	</div>

	<footer
		class="relative flex flex-col xl:flex-row items-center justify-center xl:justify-between px-4 md:px-8 lg:px-16 xl:px-24 min-h-[320px] md:min-h-[400px] lg:min-h-[480px] xl:h-[544px] py-12 md:py-16 lg:py-20 xl:py-[8.5rem] gap-10 md:gap-12 lg:gap-14 xl:gap-16 overflow-hidden"
		class:bg-hazelnut-400={isHomepage}
		class:bg-[#B85233]={!isHomepage}
		style={!isHomepage ? "filter: brightness(1);" : ""}
	>
		<img
			src={decorationFooter}
			alt="Dekorativní obrázek"
			class="pointer-events-none absolute left-0 right-0 bottom-0 md:top-auto md:bottom-0 xl:top-[6.5rem] h-[60%] md:h-[80%] xl:h-[43rem] w-full scale-110 md:scale-[1.15] lg:scale-[1.2] xl:scale-125 object-bottom"
			style={!isHomepage
				? "filter: brightness(0) saturate(100%) invert(42%) sepia(36%) saturate(958%) hue-rotate(332deg) brightness(98%) contrast(88%);"
				: ""}
		/>

		<Icon
			icon={logo}
			class="w-[16rem] sm:w-[20rem] md:w-[24rem] lg:w-[28rem] xl:w-[31.25rem] xl:h-[6.6875rem] relative z-10 {isHomepage
				? 'text-[#F7CFCF]'
				: 'text-[#21212F]'}"
		/>

		<div class="flex flex-col items-center xl:items-end gap-4 md:gap-5 xl:gap-4 relative z-10 xl:flex-1">
			<a
				href="tel:+420727955703"
				class="font-heading font-bold text-base md:text-lg lg:text-xl xl:text-[2rem] leading-[1.3] md:leading-[1.4] lg:leading-[1.5] xl:leading-[2.375rem] transition-colors text-center xl:text-right whitespace-nowrap"
				class:text-ivory-100={isHomepage}
				class:hover:text-copper-20-300={isHomepage}
				class:text-[#F7F3EF]={!isHomepage}
				class:hover:text-ivory-400={!isHomepage}
			>
				<Formatted text="+420 727 955 703" />
			</a>
			<a
				href="mailto:info@headspa-napohodu.cz"
				class="font-heading font-bold text-base md:text-lg lg:text-xl xl:text-[2rem] leading-[1.3] md:leading-[1.4] lg:leading-[1.5] xl:leading-[2.375rem] transition-colors text-center xl:text-right break-words"
				class:text-ivory-100={isHomepage}
				class:hover:text-copper-20-300={isHomepage}
				class:text-[#F7F3EF]={!isHomepage}
				class:hover:text-ivory-400={!isHomepage}
			>
				<Formatted text="info@headspa-napohodu.cz" />
			</a>
			<a
				href="/gdpr"
				class="font-heading font-bold text-base md:text-lg lg:text-xl xl:text-[2rem] leading-[1.3] md:leading-[1.4] lg:leading-[1.5] xl:leading-[2.375rem] transition-colors text-center xl:text-right"
				class:text-ivory-100={isHomepage}
				class:hover:text-copper-20-300={isHomepage}
				class:text-[#F7F3EF]={!isHomepage}
				class:hover:text-ivory-400={!isHomepage}
			>
				<Formatted text="Ochrana osobních údajů" />
			</a>
		</div>
	</footer>
</div>
